var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 637.87 134.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#051c2c;}.cls-2{fill:#009ade;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.06,113.13V50.06h25.59q9.73,0,15.72,5.45t6,14.64A18.32,18.32,0,0,1,253,88.54l13.43,24.59H253.3L240.6,89.71h-9.38v23.42Zm12.16-34h12.44q10.36,0,10.36-9t-10.36-9.1H231.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M303.55,96.65l8.2,7.2q-7.29,10.64-19.73,10.63-10,0-16.31-6.89T269.4,89.26q0-11.45,6.26-18.34A20.45,20.45,0,0,1,291.48,64a20.15,20.15,0,0,1,15.72,6.89q6.17,6.89,6.17,18.34v3.51H281.3q.27,5.49,3,8.43a9.84,9.84,0,0,0,7.53,2.92,10.69,10.69,0,0,0,6.71-2A23.29,23.29,0,0,0,303.55,96.65ZM281.3,84H302a11,11,0,0,0-3.15-7.16,10.28,10.28,0,0,0-7.39-2.57,9.51,9.51,0,0,0-7.08,2.79A10.88,10.88,0,0,0,281.3,84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M349.19,93.85l11.08,2.88q-1.62,8.56-7,13.16t-13.61,4.59a21,21,0,0,1-16-6.66q-6.27-6.67-6.27-18.56t6.45-18.52A21.13,21.13,0,0,1,339.73,64a19.8,19.8,0,0,1,13.43,4.68,20.21,20.21,0,0,1,6.66,12.53l-10.9,2.07q-1.71-8.75-9.19-8.74a9.5,9.5,0,0,0-7.88,3.74q-2.94,3.73-2.93,11t2.88,10.94a9.43,9.43,0,0,0,7.93,3.74Q347.65,103.94,349.19,93.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M402.31,107.82a22.65,22.65,0,0,1-32.08,0q-6.32-6.67-6.31-18.56,0-11.72,6.49-18.47a22,22,0,0,1,31.72,0q6.48,6.75,6.48,18.47Q408.61,101.14,402.31,107.82Zm-24-7.66a10.17,10.17,0,0,0,15.86,0q2.88-3.83,2.88-10.85T394.15,78.4a10.07,10.07,0,0,0-15.77-.05q-2.92,3.8-2.92,10.91T378.34,100.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M416.05,122.87l8.74-6a15.9,15.9,0,0,0,4.68,5.9,11.49,11.49,0,0,0,6.76,1.85,10.83,10.83,0,0,0,7.35-2.39q2.75-2.39,2.74-7.61v-6h-.18a11,11,0,0,1-4.68,4.19,15.24,15.24,0,0,1-7.21,1.75,20.14,20.14,0,0,1-15.41-6.71q-6.21-6.7-6.22-18.51,0-11.62,6.4-18.43A20,20,0,0,1,434.07,64q8.21,0,12.62,5.94h.18V65.38H458v47.75q0,10.45-6.08,16t-15.73,5.59a23.37,23.37,0,0,1-12.66-3.25A18.89,18.89,0,0,1,416.05,122.87Zm30.27-28.75V84.3a9.46,9.46,0,0,0-2.79-6.89,10,10,0,0,0-7.48-2.84,10.63,10.63,0,0,0-8.47,3.78q-3.24,3.8-3.24,10.91t3.29,10.9a10.66,10.66,0,0,0,8.42,3.78,10,10,0,0,0,7.48-2.84A9.55,9.55,0,0,0,446.32,94.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M467.18,113.13V65.38h11.27V70h.18a15.58,15.58,0,0,1,5.4-4.23A16,16,0,0,1,491.24,64q7.93,0,12.44,4.73t4.5,13.11v31.26H496.47V84.75q0-4.95-1.89-7.43t-6.49-2.48a8.48,8.48,0,0,0-9.19,9.1v29.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M519.65,133.41l9.55-22.62L510.1,65.38H522l12.35,32.35h.18l12.34-32.35h11.9l-27.49,68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M568,96.1V75.29h-7.38V65.38h7.65V53.66h11.09V65.38H591.4v9.91H579.51V95q0,3.8,1.26,5.32t5.14,1.53h3.87v11.26h-5q-9.63,0-13.24-4T568,96.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M628.05,96.65l8.2,7.2q-7.31,10.64-19.74,10.63-10,0-16.3-6.89T593.9,89.26q0-11.45,6.26-18.34A20.42,20.42,0,0,1,616,64a20.17,20.17,0,0,1,15.73,6.89q6.16,6.89,6.17,18.34v3.51H605.79q.27,5.49,3,8.43a9.81,9.81,0,0,0,7.52,2.92,10.72,10.72,0,0,0,6.72-2A23.51,23.51,0,0,0,628.05,96.65ZM605.79,84h20.73a11,11,0,0,0-3.16-7.16A10.25,10.25,0,0,0,616,74.3a9.49,9.49,0,0,0-7.07,2.79A10.94,10.94,0,0,0,605.79,84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.94,68.61.42,129.88a3.23,3.23,0,0,0,2.82,4.82H41.35L57,107.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.49,6.47,52.16,39l54.46,95.7H146.2a3.23,3.23,0,0,0,2.78-4.87L76.09,6.41A3.23,3.23,0,0,0,70.49,6.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.53,0l46.11,82,45-77.11A3.23,3.23,0,0,0,194.82,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.d35e11cf47f11e6fb367a99c65347456.svg";
export { ForwardRef as ReactComponent };